import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { getTransactionsNotAllowed, joinTransactionTypes } from './helpers'

const useAvailableTransactionTypesForRegion = ({
  availableTransactionTypes,
  availableTransactionTypesForRegion,
  allowsUnifiedFlow,
  autoOpenModal = false,
}) => {
  const { t, i18n } = useTranslation()
  const [showTransactionTypesNotAllowedModal, setShowTransactionTypesNotAllowedModal] = useState(false)
  const [transactionsNotAllowed, setTransactionsNotAllowed] = useState([])

  useEffect(() => {
    if (availableTransactionTypes && availableTransactionTypesForRegion) {
      const transactionNotAllowedResult = getTransactionsNotAllowed(
        availableTransactionTypes,
        availableTransactionTypesForRegion
      )
      setTransactionsNotAllowed(transactionNotAllowedResult)

      if (
        transactionNotAllowedResult?.length &&
        !localStorage.getItem('transactionsTypeNotAllowedShown') &&
        autoOpenModal
      ) {
        localStorage.setItem('transactionsTypeNotAllowedShown', true)
        setShowTransactionTypesNotAllowedModal(true)
      }
    }
  }, [allowsUnifiedFlow, autoOpenModal, availableTransactionTypes, availableTransactionTypesForRegion])

  const closeTransactionTypesNotAllowedModal = () => {
    setShowTransactionTypesNotAllowedModal(false)
  }

  const getTransactionsNotAllowedText = () => {
    return joinTransactionTypes(transactionsNotAllowed, t, i18n.language)
  }

  return {
    showTransactionTypesNotAllowedModal,
    setShowTransactionTypesNotAllowedModal,
    closeTransactionTypesNotAllowedModal,
    transactionsNotAllowed,
    getTransactionsNotAllowedText,
  }
}

export default useAvailableTransactionTypesForRegion
